import i18n from '@/i18n'

export default [
  {
    path: '/register',
    component: () => import('@/views/register/index.vue'),
    meta: {
      title: i18n.t('sign.register')
    }
  }
]